import firebase from "firebase/app";

import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/performance";

import {
  useFirebaseEmulator,
} from "./data/season-constants";

const firebaseConfig = {
  apiKey: "AIzaSyCkJHbBiwkX6QXo-h-xoqRmtxXt6OgpbNk",
  authDomain: "neilsfantasyfootball-3b737.firebaseapp.com",
  projectId: "neilsfantasyfootball-3b737",
  storageBucket: "neilsfantasyfootball-3b737.appspot.com",
  messagingSenderId: "392861615874",
  appId: "1:392861615874:web:dd1406df05b78f609be41b",
  measurementId: "G-Z4KJWZPG10"
};

firebase.initializeApp(firebaseConfig);

export default firebase;

const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = firebase.storage();

// eslint-disable-next-line no-restricted-globals
if (useFirebaseEmulator && window.location.hostname === 'localhost') {
  firestore.useEmulator('localhost', 8080);
  auth.useEmulator('http://localhost:9099/', { disableWarnings: true });
  storage.useEmulator("localhost", 9199);
}

export { auth, firestore, storage }; 

export const performance = firebase.performance();

export let analytics;

if (process.env.NODE_ENV !== "test") {
  analytics = firebase.analytics();
}

export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  enableClaims: true
}

export const firestoreConstants = {
  populateUserIds: [{
    child: "userId",
    root: "users",
  }],
};
